import React from 'react';
import {Button} from '@material-ui/core';
import {ErrorHelper, FormikValues, TextField, TextFieldCommon} from "../formikFormInputs";
import {Label} from "../formInputs";


interface RequestChangesFormProps extends FormikValues {}

const RCForm = ({errors, handleChange, handleSubmit, submitting, values}: RequestChangesFormProps) => {
    const messageLabel = "Enter changes do you want to request from your agent.";
    const messageField = {
        component: TextField,
        disabled: submitting,
        label: <Label label={messageLabel} required={true}/>,
        multiline: true,
        name: "message",
        placeholder: messageLabel,
        rows: 5,
        variant: "outlined",
    };
    return (
            <form onSubmit={handleSubmit}>
                <TextFieldCommon
                        {...messageField}
                        onChange={handleChange}
                        values={values}
                />
                <ErrorHelper errors={errors} name={messageField.name} />

                <Button className="mr10 mt10" color="primary" disabled={submitting} type="submit" variant="contained">
                    Send
                </Button>
            </form>
    );
}

export default RCForm;
